import { Pipe, PipeTransform } from '@angular/core';
import { SecuredResourceResolverService } from '@shared/components/secured-resource/secured-resource-resolver.service';
import { Observable } from 'rxjs';

@Pipe({
  name: 'secureVideoUrlPipe',
  standalone: false,
})
export class SecureVideoUrlPipePipe implements PipeTransform {
  constructor(private securedResourceResolver: SecuredResourceResolverService) {}

  transform(url: string): Observable<Object> | null {
    if (!url) {
      return null;
    }
    return this.securedResourceResolver.loadSanitizedVideoUri(url);
  }
}
